import { combineReducers } from 'redux';
import {
  GET_NUTRITION_PLANS_SUCCEEDED,
  GET_NUTRITION_PLANS_ERROR,
  GET_CLIENT_NUTRITION_PLANS_SUCCEEDED,
  GET_CLIENT_NUTRITION_PLANS_ERROR,
  GET_NUTRITION_PLAN_SUCCEEDED,
  GET_NUTRITION_PLAN_ERROR,
  ASSIGN_CLIENT_TO_PLANS_ERROR,
  ASSIGN_PLAN_TO_CLIENTS_ERROR,
  RENAME_PLAN_ERROR,
  CREATE_PLAN_ERROR,
  DELETE_PLAN_ERROR,
  UNASSIGN_CLIENT_FROM_PLAN_ERROR,
  UNASSIGN_CLIENT_FROM_PLAN_SUCCEEDED,
  CREATE_MEAL_ERROR,
  EDIT_MEAL_ERROR,
  SEARCH_FOOD_SUCCEEDED,
  SEARCH_FOOD_ERROR,
  CREATE_FOOD_ERROR,
  LOADING_FOOD,
  NUTRATION_LOADING_STATE,
  CURRENT_NUTRATION_LOADING_STATE,
  CLIENT_NUTRATION_LOADING_STATE,
  GET_MEASUREMENTS_SUCCEEDED,
  GET_MEASUREMENTS_ERROR,
  LOADING_MEASUREMENTS,
  DELETE_MEAL_SUCCEEDED,
  DELETE_MEAL_ERROR
} from './types';

const INITIAL_STATE = {
  trainerNutrition: { plans: [] },
  clientNutrition: { plans: [] },
  currentNutritionPlan: null,
  food: {
    search: {},
    lastQuery: null,
    loadingFood: false,
    measurementsUnits: [],
    loadingMeasurements: false
  },
  nutrationLoadingState: false
};

function trainerNutrition(state = INITIAL_STATE.trainerNutrition, action) {
  if (action.type === GET_NUTRITION_PLANS_SUCCEEDED) {
    return { ...action.payload, nutrationLoadingState: false };
  } else if (action.type === GET_NUTRITION_PLANS_ERROR) {
    return { ...state, error: action.payload, nutrationLoadingState: false };
  } else if (action.type === CREATE_MEAL_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === EDIT_MEAL_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === NUTRATION_LOADING_STATE) {
    return { ...state, nutrationLoadingState: true };
  } else {
    return state;
  }
}

function clientNutrition(state = INITIAL_STATE.clientNutrition, action) {
  if (action.type === GET_CLIENT_NUTRITION_PLANS_SUCCEEDED) {
    return { ...action.payload, clientNutritionLoading: false };
  } else if (action.type === GET_CLIENT_NUTRITION_PLANS_ERROR) {
    return { ...state, error: action.payload, clientNutritionLoading: false };
  } else if (action.type === ASSIGN_CLIENT_TO_PLANS_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === ASSIGN_PLAN_TO_CLIENTS_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === CLIENT_NUTRATION_LOADING_STATE) {
    return { ...state, clientNutritionLoading: true };
  } else {
    return state;
  }
}

function currentNutritionPlan(
  state = INITIAL_STATE.currentNutritionPlan,
  action
) {
  if (action.type === GET_NUTRITION_PLAN_SUCCEEDED) {
    return { ...action.payload, currentNutrationLoadingState: false };
  } else if (action.type === UNASSIGN_CLIENT_FROM_PLAN_SUCCEEDED) {
    return action.payload;
  } else if (action.type === GET_NUTRITION_PLAN_ERROR) {
    return {
      ...state,
      error: action.payload,
      currentNutrationLoadingState: false
    };
  } else if (action.type === RENAME_PLAN_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === CREATE_PLAN_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === DELETE_PLAN_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === UNASSIGN_CLIENT_FROM_PLAN_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === CURRENT_NUTRATION_LOADING_STATE) {
    return { ...state, currentNutrationLoadingState: true };
  } else if (action.type === DELETE_MEAL_SUCCEEDED) {
    return { ...action.payload, currentNutrationLoadingState: false };
  } else if (action.type === DELETE_MEAL_ERROR) {
    return { ...state, error: action.payload };
  } else {
    return state;
  }
}

function food(state = INITIAL_STATE.food, action) {
  if (action.type === SEARCH_FOOD_SUCCEEDED) {
    if (state.lastQuery !== action.payload.query) return state;
    return {
      search: action.payload.search,
      loadingFood: false
    };
  } else if (action.type === SEARCH_FOOD_ERROR) {
    if (state.lastQuery !== action.payload.query) return state;
    return { ...state, error: action.payload, loadingFood: false };
  } else if (action.type === CREATE_FOOD_ERROR) {
    return { ...state, error: action.payload };
  } else if (action.type === LOADING_FOOD) {
    return { ...state, lastQuery: action.payload, loadingFood: true };
  }  else if (action.type === GET_MEASUREMENTS_SUCCEEDED) {
    return { ...state, measurementsUnits: action.payload, loadingMeasurements: false };
  } else if (action.type === GET_MEASUREMENTS_ERROR) {
    return { ...state, error: action.payload, loadingMeasurements: false };
  } else if (action.type === LOADING_MEASUREMENTS) {
    return { ...state, loadingMeasurements: true };
  } else {
    return state;
  }
}

export default combineReducers({
  trainerNutrition,
  clientNutrition,
  currentNutritionPlan,
  food
});
